<template>
  <section
    class="slide slideBlack contactus kenBurns overflow-hidden opacity-0 fixed w-full h-full"
    name="contactus"
  >
    <div class="content overflow-hidden absolute left-0 top-0 w-full h-full z-20">
      <div class="container max-w-full table w-full h-full table relative table-fixed">
        <div class="wrap table-cell align-middle text-center">
          <div class="fix-width max-w-922px ml-auto mr-auto text-center">
            <p
              v-if="title1"
              class="cropBottom middle ae-1 fromCenter opacity-80 font-anonymouse text-sm leading-lh3"
            >{{title1}}</p>
            <p
              v-if="title2"
              class="cropBottom middle ae-1 fromCenter opacity-80 font-anonymouse text-sm leading-lh3 pb-spc24"
            >{{title2}}</p>
          </div>
          <div class="fix-width max-w-1114px ml-auto mr-auto text-center">
            <div class="purchaseBtns">
              <SectionDetailsButtons
                :btn1title="contactbtnTxt"
                :btn1url="contactbtnUrl"
                btn1class="button purchase ae-6 fromCenter border-white"
              />
            </div>
          </div>
          <div v-if="email" class="fix-width max-w-922px ml-auto mr-auto text-center">
            <div class="details cropBottom middle ae-8 fromBottom">
              <a
                :href="'mailto:'+email"
                class="contactemail leading-10 text-size1 opacity-100 text-white font-anonymouse"
              >{{email}}</a>
            </div>
          </div>
          <div class="fix-width max-w-1114px ml-auto mr-auto text-center">
            <div class="purchaseBtns">
              <SectionDetailsButtons
                :btn1title="productbtnTxt"
                :btn1url="productbtnUrl"
                btn1class="ae-6 fromCenter border-white w-spc25"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <PrevButton
      :title="prevBtnText"
      :copyright="prevBtnText2"
      :developeby="developeby"
      :developerUrl="devUrl"
    />

    <div
      class="background absolute top-0 left-0 w-full h-full bg-center bg-cover bg-no-repeat"
      :style="{backgroundImage: 'url('+bgImg+')'}"
    ></div>
  </section>
</template>

<script>
import SectionDetailsButtons from "../common/SectionDetailsButtons";
import PrevButton from "../common/PrevButton";

export default {
  name: "Section15",
  props: [
    "title1",
    "title2",
    "bgImg",
    "email",
    "prevBtnText",
    "prevBtnText2",
    "contactbtnTxt",
    "contactbtnUrl",
    "productbtnTxt",
    "productbtnUrl",
    "developeby",
    "devUrl"
  ],
  components: {
    PrevButton,
    SectionDetailsButtons
  }
};
</script>

<style scoped>
</style>